import { Alert } from 'antd';
import { useTranslate } from '@tolgee/react';

export const PlatformProductNotice = () => {
  const { t } = useTranslate();
  return (
    <section>
      <Alert type="info" showIcon message={t('基于平台中的原始 商品标题和描述信息回复')} />
    </section>
  );
};
